<template>
  <div class="recently_added__items">
    <vs-card class="cardx bg-green-500">
      <vs-table stripe maxHeight="500px" :sst="true" :data="recently_added_items">
        <template slot="header">
          <!-- TABLE ACTION ROW -->
          <p class="font-bold text-xl mb-2">Recently Added Items</p>
        </template>

        <template slot="thead">
          <vs-th>Sl. No</vs-th>
          <vs-th>Item Name</vs-th>
          <vs-th>Item Sales Price</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ i + 1 }}
            </vs-td>
            <vs-td>
              {{ tr.product_name }}
            </vs-td>
            <vs-td> $ {{ tr.sales_price | currencyFilter }} </vs-td>
          </vs-tr>

          <vs-tr>
            <vs-td colspan="3" class="text-center">
              <span class="cursor-pointer" @click="$router.push({ name: 'product-list' }).catch(() => {})"> View More </span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { paymentMixins } from '@/utils/paymentTypes'

export default {
  name: 'RecentlyAddedItems',

  async mounted() {
    // get dashboard recently added items
    await this.fetch_recently_added_items()
  },

  mixins: [paymentMixins],

  computed: {
    ...mapState('dashboard', ['recently_added_items'])
  },
  methods: {
    ...mapActions('dashboard', { fetch_recently_added_items: 'getRecentAddedData' })
  },

  // filters
  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    }
  }
}
</script>

<style></style>
